import { useContentManager } from '../../hooks/useContentManager';

export default function HomeIntro() {
  const { getContentItem } = useContentManager();

  // Admin-managed: page='home', section='intro'
  const introItem = getContentItem('home', 'intro');
  const titleLine1 = introItem?.metadata?.title_line1 || 'WHY';
  const titleBold = introItem?.metadata?.title_bold || 'Golden Tower?';
  const description = introItem?.metadata?.description ||
    'Golden Tower, delve deeper into the design philosophy where every element is carefully considered to create a poised way of life, truly embracing its name. Discover residences crafted with exquisite materials, each a testament to Golden Tower\'s unwavering pursuit of perfection.';
  const buttonText = introItem?.metadata?.button_text || 'REGISTER YOUR INTEREST';
  const buttonUrl = introItem?.metadata?.button_url || '/new-releases';

  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-light mb-6">
          {titleLine1} <span className="font-bold">{titleBold}</span>
        </h2>
        <p className="text-gray-300 max-w-4xl mx-auto mb-10 leading-relaxed">
          {description}
        </p>
        {buttonText && (
          <a
            href={buttonUrl}
            className="inline-block border border-white px-8 py-3 text-sm tracking-wider hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {buttonText}
          </a>
        )}
      </div>
    </section>
  );
}
